import React, { useState } from 'react';
import { BookOpen, ArrowRight, X } from 'lucide-react';
import { bookPresaleUrl } from '../siteConfig';

const KEY = 'bookBannerDismissed';

const AnnouncementBar = ({ text }) => {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem(KEY));
  if (!visible || !text) return null;

  const dismiss = () => {
    sessionStorage.setItem(KEY, '1');
    setVisible(false);
  };

  return (
    <div className="w-full" style={{ background: 'var(--navy)' }} data-testid="book-announcement-bar">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center justify-center gap-2 sm:gap-3 relative">
        <BookOpen className="hidden sm:block w-4 h-4 shrink-0" style={{ color: 'var(--gold)' }} />
        <p className="font-body text-xs sm:text-sm text-white/90 text-center leading-snug pr-6 sm:pr-0">
          {text.message}{' '}
          <a
            href={bookPresaleUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-head font-bold inline-flex items-center gap-1 underline-offset-4 hover:underline whitespace-nowrap"
            style={{ color: 'var(--gold)' }}
            data-testid="book-announcement-link"
          >
            {text.cta} <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </p>
        <button
          onClick={dismiss}
          aria-label={text.dismiss}
          className="absolute right-3 md:right-6 p-1 rounded text-white/60 hover:text-white transition-colors"
          data-testid="book-announcement-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
